/* eslint-disable @typescript-eslint/no-unsafe-return */
/* eslint-disable import/named */
import {Navigate, Route, Routes as RoutesP} from 'react-router-dom';
import SignUp from 'pages/SignUp';
import {SignIn} from 'pages/SignIn';
import {Dashboard} from 'pages/Dashboard';
import NotFound from 'pages/NotFound';
import Cards from 'pages/Cards';
import Charts from 'pages/Charts';
import {Policy} from 'pages/Policy';
import {Configuration} from 'pages/Configuration';
import {Users, UsersEditOrCreate} from 'pages/Users';
import {SessionDataQuery} from 'pages/SessionDataQuery';
import PolicyViewOrEdit from 'pages/Policy/PolicyViewOrEdit';
import {
	SubscriberHome,
	SubscriberOperatorsDetail,
	SubscriberProfileDetail,
} from 'pages/SubscriberProfile';
import SubscriberPlanDetail from 'pages/SubscriberProfile/SubscriberPlanDetail';
import {useAppSelector} from 'store/hooks';
import {hasRole} from 'utils';
import NotPermission from 'components/NotPermission';
import NotAuthorize from 'pages/NotFound/NotAuthorize';
import CustomRouter from 'CustomRouter';

type TRenderRoute = {
	key: string[];
	component: JSX.Element;
};

const Routes = () => {
	const {token, roles} = useAppSelector(state => state.user);

	const isLoggedIn = token !== null;
	const renderRoute = ({key, component}: TRenderRoute) => (
		<>
			{hasRole(roles, key) ? (
				component
			) : (
				<Route path="/dashboard" element={<NotPermission />} />
			)}
		</>
	);

	return (
		<CustomRouter>
			<RoutesP>
				{!isLoggedIn ? (
					<Route
						path="/"
						element={!isLoggedIn ? <SignIn /> : <Navigate to="/dashboard" />}
					/>
				) : (
					<>
						{renderRoute({
							component: <Route path="/dashboard" element={<Dashboard />} />,
							key: ['monitoring', 'monitoring_read_only'],
						})}

						{renderRoute({
							component: <Route path="/policy" element={<Policy />} />,
							key: ['policy_engine', 'policy_engine_read_only'],
						})}

						{renderRoute({
							component: (
								<Route path="/policy/view" element={<PolicyViewOrEdit />} />
							),
							key: ['policy_engine', 'policy_engine_read_only'],
						})}

						{renderRoute({
							component: (
								<Route path="/policy/edit" element={<PolicyViewOrEdit />} />
							),
							key: ['policy_engine', 'policy_engine_read_only'],
						})}

						{renderRoute({
							component: (
								<Route path="/configuration" element={<Configuration />} />
							),
							key: ['system_admin', 'system_admin_read_only'],
						})}

						{renderRoute({
							component: <Route path="/users" element={<Users />} />,
							key: ['admin'],
						})}

						{renderRoute({
							component: (
								<Route path="/users/create" element={<UsersEditOrCreate />} />
							),
							key: ['admin'],
						})}

						{renderRoute({
							component: (
								<Route
									path="/users/edit/:username"
									element={<UsersEditOrCreate />}
								/>
							),
							key: ['admin'],
						})}

						{renderRoute({
							component: (
								<Route
									path="/sessionDataQuery"
									element={<SessionDataQuery />}
								/>
							),
							key: ['monitoring', 'monitoring_read_only'],
						})}

						{renderRoute({
							component: (
								<Route path="/subscriberProfile" element={<SubscriberHome />} />
							),
							key: [
								'subscriber_provision',
								'subscriber_read_only',
								'plan_provision',
								'plan_read_only',
							],
						})}

						{renderRoute({
							component: (
								<Route
									path="/subscriberProfile/detail/:id?"
									element={<SubscriberProfileDetail />}
								/>
							),
							key: [
								'subscriber_provision',
								'subscriber_read_only',
								'plan_provision',
								'plan_read_only',
							],
						})}

						{renderRoute({
							component: (
								<Route
									path="/subscriberPlan/detail/:id?"
									element={<SubscriberPlanDetail />}
								/>
							),
							key: [
								'subscriber_provision',
								'subscriber_read_only',
								'plan_provision',
								'plan_read_only',
							],
						})}

						{renderRoute({
							component: (
								<Route
									path="/subscriberOperators/detail/:id?"
									element={<SubscriberOperatorsDetail />}
								/>
							),
							key: [
								'subscriber_provision',
								'subscriber_read_only',
								'plan_provision',
								'plan_read_only',
							],
						})}

						<Route path="/signup" element={<SignUp />} />
						<Route path="/cards" element={<Cards />} />
						<Route path="/charts" element={<Charts />} />
					</>
				)}
				<Route path="*" element={<NotFound />} />
				<Route path="/notAuthorize" element={<NotAuthorize />} />
			</RoutesP>
		</CustomRouter>
	);
};

export default Routes;
